import React from 'react'

import { Button } from 'components'
import { Lock } from 'assets/svgs'

import { isAuctionCheck } from 'store/property/utils'
import styles from './ActionButton.module.scss'

const ActionButton = ({
  show,
  callToActionLabel,
  callToActionUrl = '',
  isConcurrenceOver,
  isAuction,
  handleActionButton,
  isPreActive,
  idButton = '',
  saleType = '',
}) => {
  const notFinishedActionLabel = callToActionLabel !== 'Encerrado'
  const sold = callToActionLabel === 'Vendido'
  const auctionWithoutUrl = isAuction && !callToActionUrl
  const isConcurrenceOverOrPreActive = isConcurrenceOver || isPreActive

  if (isAuctionCheck(saleType) && !callToActionUrl && show) {
    return (
      <Button
        id="ver_leilao_em_breve"
        name="possibleFixedButton"
        className={styles.largeButton}
        type="filled"
        fontSize="medium"
        disabled
      >
        Em breve
      </Button>
    )
  }

  const callToActionButtonDisabled =
    ((sold || auctionWithoutUrl) && notFinishedActionLabel) ||
    isConcurrenceOverOrPreActive

  return (
    show && (
      <Button
        id={idButton}
        name="possibleFixedButton"
        className={styles.largeButton}
        type="filled"
        onClick={handleActionButton}
        fontSize="medium"
        disabled={callToActionButtonDisabled}
      >
        {isPreActive && <Lock size={20} color="#FFF" />} {callToActionLabel}
      </Button>
    )
  )
}

export default React.memo(ActionButton)
